import { render, staticRenderFns } from "./RegionPicker.vue?vue&type=template&id=bac88df4&scoped=true&"
import script from "./RegionPicker.vue?vue&type=script&lang=js&"
export * from "./RegionPicker.vue?vue&type=script&lang=js&"
import style0 from "./RegionPicker.vue?vue&type=style&index=0&id=bac88df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bac88df4",
  null
  
)

export default component.exports